import MuiToolbar, { ToolbarProps as MuiToolbarProps } from '@mui/material/Toolbar';
import React from 'react';

export interface ToolbarProps extends MuiToolbarProps {}

export const Toolbar = (props: ToolbarProps) => {
  return <MuiToolbar {...props} />;
};
